@if (ready()) {
  <app-navbar></app-navbar>
  <main>
    <router-outlet></router-outlet>
  </main>
}
